import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CVMState } from './cvm.state';

export const selectCVMState = createFeatureSelector<CVMState>('cvm');

export const selectCandidateVerifications = createSelector(selectCVMState, state => state.candidateVerifications);
export const selectCandidateVerificationsPagination = createSelector(
  selectCVMState,
  state => state.candidateVerificationsPagination
);
export const selectLoadingCandidateVerifications = createSelector(
  selectCVMState,
  state => state.loadingCandidateVerifications
);

export const selectCandidateVerificationDetails = createSelector(
  selectCVMState,
  state => state.candidateVerificationDetails
);
export const selectLoadingCandidateVerificationDetails = createSelector(
  selectCVMState,
  state => state.loadingCandidateVerificationDetails
);
export const selectUpdatingCandidateVerificationStatus = createSelector(
  selectCVMState,
  state => state.updatingCandidateVerificationStatus
);
export const selectLoadingSavingCandidateVerificationResult = createSelector(
  selectCVMState,
  state => state.loadingSavingCandidateVerificationResult
);
export const selectRequestingCandidateVerificationSupplementaryInfo = createSelector(
  selectCVMState,
  state => state.requestingCandidateVerificationSupplementaryInfo
);
export const selectDownloadingCandidateVerificationFileId = createSelector(
  selectCVMState,
  state => state.downloadingCandidateVerificationFileId
);
export const selectDeletingCandidateVerification = createSelector(
  selectCVMState,
  state => state.deletingCandidateVerification
);

export const selectCandidateVerificationHistory = createSelector(
  selectCVMState,
  state => state.candidateVerificationHistory
);
export const selectLoadingCandidateVerificationHistory = createSelector(
  selectCVMState,
  state => state.loadingCandidateVerificationHistory
);

export const selectCVMErrorMessage = createSelector(selectCVMState, state => state.errorMessage);
